import OtpInput from "react-otp-input"
import useOtpInput from "./useOtpInput"

const OtpInputPage = () => {
    const {
        otp,
        baseUrl,
        status,
        error,
        handleChangeOtp,
        handleSubmit,
    } = useOtpInput()

    return (
        <main>
            <div className="container">
                <section className="section register min-vh-100 d-flex flex-column align-items-center justify-content-center py-4">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-4 col-md-6 d-flex flex-column align-items-center justify-content-center">

                                {/* {status === "succeeded" && (
                                    <div className="alert alert-success alert-dismissible fade show w-100">
                                        OTP verified successfully!
                                        <button type="button" className="btn-close" data-bs-dismiss="alert" />
                                    </div>
                                )} */}

                                <div className="card mb-3">
                                    <div className="card-body auth-login">

                                        <div className="pt-4 pb-4">
                                            <div className="d-flex justify-content-center mb-3">
                                                <img
                                                    src={`${baseUrl}/assets/img/kemenag_logo_mini.png`}
                                                    style={{ width: "100px" }}
                                                    alt="Logo"
                                                />
                                            </div>

                                            <h5 className="card-title text-center fs-4">
                                                Masukkan Kode MFA
                                            </h5>
                                            <p className="text-center small">
                                                Silakan masukkan 6 digit kode OTP
                                            </p>

                                            {status === "failed" && (
                                                <div className="alert alert-danger alert-dismissible fade show">
                                                    {error?.message || "OTP verification failed"}
                                                    <button type="button" className="btn-close" data-bs-dismiss="alert" />
                                                </div>
                                            )}
                                        </div>

                                        <form className="row g-3" onSubmit={handleSubmit}>
                                            <div className="col-12 d-flex justify-content-center">
                                                <OtpInput
                                                    value={otp}
                                                    onChange={handleChangeOtp}
                                                    numInputs={6}
                                                    renderSeparator={<span>&nbsp;&nbsp;</span>}
                                                    renderInput={(props) => <input {...props} />}
                                                    inputStyle={{
                                                        width: "40px",
                                                        height: "40px",
                                                        fontSize: "20px",
                                                        textAlign: "center",
                                                        borderRadius: "8px",
                                                        border: "1px solid #ced4da",
                                                    }}
                                                />
                                            </div>

                                            <div className="col-12 mt-4">
                                                <button
                                                    className="btn btn-primary w-100 py-2"
                                                    type="submit"
                                                >
                                                    Verifikasi OTP
                                                </button>
                                            </div>
                                        </form>

                                    </div>
                                </div>

                                <div className="credits">
                                    Designed by <a href="#">PUSDATIN</a>
                                </div>

                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </main>
    )
}

export default OtpInputPage
